import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { User } from '@/modules/user/models/User';

export class ProtectionMandataryVerifier extends BaseEntityModel {
  id?: number;
  protectionMandateId?: number;
  userId?: number;
  protectionType?: string;
  type?: string;
  frequency?: string;
  user: Relationship<User> | null;

  constructor(model: Partial<ProtectionMandataryVerifier> = {}) {
    super(model);

    this.id = model.id;
    this.protectionMandateId = model.protectionMandateId;
    this.userId = model.userId;
    this.protectionType = model.protectionType;
    this.type = model.type;
    this.frequency = model.frequency;

    this.user = User.mapModelOrNull(model.user);
  }

  clone(): ProtectionMandataryVerifier {
    return ProtectionMandataryVerifier.mapModel(JSON.parse(JSON.stringify(this)));
  }
}
